import { render, staticRenderFns } from "./publishCooperationGoods.vue?vue&type=template&id=05e244f2&scoped=true"
import script from "./publishCooperationGoods.vue?vue&type=script&lang=js"
export * from "./publishCooperationGoods.vue?vue&type=script&lang=js"
import style0 from "./publishCooperationGoods.vue?vue&type=style&index=0&id=05e244f2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e244f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05e244f2')) {
      api.createRecord('05e244f2', component.options)
    } else {
      api.reload('05e244f2', component.options)
    }
    module.hot.accept("./publishCooperationGoods.vue?vue&type=template&id=05e244f2&scoped=true", function () {
      api.rerender('05e244f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/cooperation/publishCooperationGoods.vue"
export default component.exports